import {
  ConfirmationDetails,
  ResCalculatePendingRewardForStakeCall,
  ResGetPoolDetailsCall,
  ResGetStakeCall,
  ResRewardSchedules,
  TypeStakingAprroveActionPayload,
  TypeStakingPayload,
  TypeUnStakingActionPayload,
  type ContractCallType,
} from '@/types';
import { IProvider } from '@web3auth/modal';
import { TransactionReceipt, Web3 } from 'web3';
import {
  STAKKINGTOKEN,
  UNSTAKETOKEN,
  CLAIMREWARD,
  WITHDRAWALLPRINCIPAL,
  CLAIMALLREWARD,
  GETPOOLDETAILS,
  CALCULATEPENDINGREWARDFORSTAKE,
  CALCULATEPENDINGREWARDFORALLSTAKES,
  CALCULATECLAIMEDREWARDFORALLSTAKES,
  GETSTAKE,
  GETSTAKECOUNT,
  GETTOTALSTAKEDAMOUNT,
  STATE,
  REWARDSCHEDULE,
  TOTALFUNDRAISINGMULTIPLIEDPRICE,
  GETREWARDSCHEDULECOUNT,
  FACTORY_POOL_CONTRACT,
  MULTIPLIE_PERCENT,
  REQUIRED_CONFIRMATIONS,
  MIN_CONFIRMATIONS,
  MAX_CONFIRMATION_WAIT_TIME,
} from '../common/name-space';

import StakingFactoryAbi from './abi/StakingFactory.json';
import StakingAbi from './abi/StakingPool.json';
import Erc20Abi from './abi/Erc20Abi.json';

import { converterToEth, ethToWei, weiToEth } from './utils';
import { dividedNum } from '../BigNumbers';
import { unixToDate } from '../days';
import BigNumber from 'bignumber.js';
import { RES_BAD_REQUEST, RES_SUCCESS } from '@/lib/common/name-space';
import { telegramForm } from '../error-bot/telegram';
import { sleep } from '../util';

export default class StakingCall {
  private web3: Web3;
  private stakingFactory: any; // 삭제 예정
  private contracts: Record<string, any>;
  private erc20Contract: Record<string, any>;
  private readonly MAX_GAS_LIMIT = 200000; // 200,000 가스 (Approve 트랜잭션의 안전한 최대값)

  constructor(provider: IProvider) {
    this.web3 = new Web3(provider);
    this.contracts = {};
    this.erc20Contract = {};
    this.setContractFactory();
  }
  setContractFactory(factory_contract: string = FACTORY_POOL_CONTRACT) {
    const factoryContract = factory_contract.toLocaleLowerCase();
    // 신규
    // 0x9b9A5f654d74697616E64dB60eb64a5710564a0F
    this.stakingFactory = new this.web3.eth.Contract(StakingFactoryAbi, factoryContract);
    // 이전
    // this.stakingFactory = new this.web3.eth.Contract(StakingFactoryAbi, '0x0b06F87E732395d274D467F92a3883CB4D2733A1');

    // const re = await this.getAllPools();
    // if (!re || re.length === 0) {
    //   return;
    // }

    // this.setStakingContract(re);
  }
  setStakingContract(data: { pool_contract_addr: string[]; coin_contract_addr: string[] }) {
    const duplicationCoinContracts = new Set<string>(); // 중복 확인을 위한 Set

    data.pool_contract_addr.forEach((item, index) => {
      const contractAddr = item.toLocaleLowerCase();
      this.contracts[contractAddr] = new this.web3.eth.Contract(StakingAbi, contractAddr);
      const coinContractAddr = data.coin_contract_addr[index];
      if (duplicationCoinContracts.has(coinContractAddr)) {
        return;
      }
      this.erc20Contract[contractAddr] = new this.web3.eth.Contract(Erc20Abi, data.coin_contract_addr[index]);
    });
    // data.pool_contract_addr.forEach((item) => {
    //   const contractAddr = item.toLocaleLowerCase();
    //   this.contracts[contractAddr] = new this.web3.eth.Contract(StakingAbi, contractAddr);
    // });
    // this.erc20Contract = new this.web3.eth.Contract(Erc20Abi, POLYGON_SHUFFLE);

    // erc20의 토큰 컨트랙트 주소를 넣어야 함
    // TODO 고정이 아니라 서버에서 받아야 겟다.
  }

  async getAllPools(): Promise<string[]> {
    return await this.stakingFactory.methods.getAllPools().call();
  }
  async getFactoryPoolDetails(aIndex: string): Promise<ResGetPoolDetailsCall> {
    const re = await this.stakingFactory.methods.getPoolDetails(aIndex).call();
    const obj = {
      name: re.name,
      description: re.description,
      minStakePrice: String(re.minStakePrice),
      minFundraisingPrice: String(re.minFundraisingPrice),
      maxFundraisingPrice: String(re.maxFundraisingPrice),
      annualInterestMultipliedRate: dividedNum(String(re.annualInterestMultipliedRate), 100, 1),
      stakingToken: re.stakingToken,
    };
    return obj;
  }
  async gasPrice() {
    const gasPrice = await this.web3.eth.getGasPrice(); // wei
    const increaseGasPrice = BigNumber(String(gasPrice)).multipliedBy(MULTIPLIE_PERCENT).toFixed();
    return increaseGasPrice;
  }

  // async callStaking<T extends keyof TypeStakingCall>(aFunc: T, aSymbol: string, ...args: any[T]) {}
  // async stakingContract() {
  //   const re = await this.getAllPools();
  //   re.forEach((address) => {
  //     const contract = new this.web3.eth.Contract(StakingAbi, address.toLowerCase());
  //     this.contracts = contract;
  //   });
  //   // TODO 1. stakingIndex를 가져올 수 있는 방법이 있는지?
  //   //      2. staking 관련 networkList처럼 symbol, abi 받아서 컨트랙트를 관여하는 this.staking
  //   // abi는 한 개고 컨트랙트 주소는 여러개 일 경우
  // }
  async contractStakingCall<T>(aPayload: ContractCallType): Promise<T> {
    const { method, contractAddr, data } = aPayload;
    // const contract = this.contracts[symbol];
    const contract = this.contracts[contractAddr];
    const re: T = await contract.methods[method](...data).call();
    return re;
  }
  private async handleContractCall1(method: string, contractAddr: string, aPayload: TypeStakingPayload) {
    if (!method || !aPayload || !Array.isArray(aPayload)) {
      throw new Error('Invalid method or data');
    }

    // console.log(`handleContractCall1`);
    // console.log(`method: ${method}`);
    // console.log(aPayload);
    if (!contractAddr) {
      throw new Error('Invalid contractAddr');
    }
    const contractAddress = contractAddr.toLocaleLowerCase();
    try {
      const contract = this.contracts[contractAddress];
      if (!contract) {
        return { code: RES_BAD_REQUEST, data: 'contractAddress not find' };
      }
      const re = await contract.methods[method](...aPayload).call();
      // console.log(`result`);
      // console.log(re);
      return { code: RES_SUCCESS, data: re };
    } catch (e: any) {
      console.log(`eeeeeerror`);
      console.log(method);
      console.log(e);
      return { code: RES_BAD_REQUEST, data: e };
    }
  }
  private async handleContractApprove(aPayload: any) {
    try {
      const { from, approveData } = aPayload;
      const contractAddress = aPayload.contractAddr.toLocaleLowerCase();
      const contract = this.erc20Contract[contractAddress];

      if (!contract) {
        return { isApprove: false, msg: 'ERC20 contract not found', code: '400', nonce: null };
      }

      // 최신 nonce를 안전하게 가져옴 (pending 트랜잭션 포함)
      const nonce = await this.web3.eth.getTransactionCount(from, 'pending');

      // Gas 가격 및 리밋 계산 (재시도 로직 포함)
      const gasPrice = await this.gasPrice();
      // estimateGas 재시도 로직
      // estimateGas 실패 시 사용할 최대 가스량 (Approve 트랜잭션용)
      let gasEstimate;
      const estimateGasWithRetry = async (maxRetries: number = 3): Promise<bigint> => {
        for (let i = 0; i < maxRetries; i++) {
          try {
            const estimate = await contract.methods.approve(...approveData).estimateGas({ from });
            return estimate;
          } catch (e: any) {
            const errorCode = e?.error?.code || e?.code;
            const errorMessage = e?.error?.message || e?.message || '';
            const errorData = e?.error?.data || e?.data;

            // 컨트랙트 revert 에러 체크 (code: 3, message: 'execution reverted')
            // 이런 경우는 재시도하면 안 됨 - 실제 컨트랙트 실행 실패
            if (errorData?.code === 3 || errorData?.message === 'execution reverted') {
              console.error('Approve contract execution reverted - not retrying:', errorData);
              throw e; // 즉시 throw하여 사용자에게 에러 전달
            }

            // 실제 RPC 에러만 재시도
            const isRpcError =
              (errorCode === -32603 && !errorData?.code) ||
              errorCode === -32002 ||
              (errorMessage?.includes('RPC') && !errorMessage?.includes('execution reverted')) ||
              errorMessage?.includes('Internal JSON-RPC') ||
              errorMessage?.includes('not found') ||
              errorMessage?.includes('unavailable');

            if (isRpcError && i < maxRetries - 1) {
              console.log(`Approve gas estimate retry ${i + 1}/${maxRetries} due to RPC error`);
              await sleep(2000); // 2초 대기 후 재시도
              continue;
            }

            // 마지막 시도이거나 재시도 대상이 아닌 경우에도 루프를 계속 진행하여 최대 가스량 반환
            // 컨트랙트 revert 에러는 이미 위에서 throw했으므로 여기서는 RPC 에러만 처리
            if (i === maxRetries - 1) {
              // 마지막 시도이면 루프 종료 후 최대 가스량 반환
              break;
            }
            // 아직 시도할 기회가 있으면 continue하지 않고 루프를 계속 진행
            continue;
          }
        }
        // 최대 시도 후에도 실패하면 최대 가스량 사용
        console.warn(
          `⚠️ Failed to estimate approve gas after ${maxRetries} retries. Using maximum gas limit: ${this.MAX_GAS_LIMIT}`,
        );
        return BigInt(this.MAX_GAS_LIMIT);
      };

      gasEstimate = await estimateGasWithRetry();
      const gasLimit = BigNumber(String(gasEstimate)).multipliedBy(MULTIPLIE_PERCENT).toFixed(0);

      let txHash: string | null = null;
      let confirmationCount = 0;
      let receiptReceived = false;

      // Receipt를 별도로 조회하는 함수 (RPC 에러 대비)
      const fetchReceiptWithRetry = async (hash: string, maxRetries: number = 30): Promise<TransactionReceipt> => {
        for (let i = 0; i < maxRetries; i++) {
          try {
            await sleep(2000); // 2초 대기
            const receipt = await this.web3.eth.getTransactionReceipt(hash);
            if (receipt) {
              return receipt;
            }
          } catch (e: any) {
            // RPC 에러는 재시도, 다른 에러는 throw
            if (e.code === -32002 || e.message?.includes('RPC endpoint') || e.message?.includes('not found')) {
              console.log(`Receipt fetch retry ${i + 1}/${maxRetries} for tx: ${hash}`);
              continue;
            }
            throw e;
          }
        }
        throw new Error(`Failed to get transaction receipt after ${maxRetries} retries`);
      };

      // Confirmation을 수동으로 확인하는 폴링 함수 (exponential backoff 적용)
      const pollForConfirmation = async (
        hash: string,
        resolve: (receipt: TransactionReceipt) => void,
        reject: (error: Error) => void,
        maxAttempts: number = 60, // 최대 시도 횟수
      ) => {
        let lastReceipt: TransactionReceipt | null = null;
        let lastBlockNumber: number | null = null;
        let lastBlockNumberTime: number = 0;
        const BLOCK_NUMBER_CACHE_MS = 2000; // 2초간 블록 번호 캐싱

        for (let i = 0; i < maxAttempts; i++) {
          try {
            // Exponential backoff: 2초 → 4초 → 8초 (최대 8초)
            const baseDelay = 2000; // 2초
            const maxDelay = 8000; // 최대 8초
            const delay = Math.min(baseDelay * Math.pow(2, Math.floor(i / 3)), maxDelay);

            if (i > 0) {
              await sleep(delay);
            }

            const receipt = await this.web3.eth.getTransactionReceipt(hash);

            if (receipt) {
              lastReceipt = receipt;

              // 블록 번호 캐싱: 같은 블록 내에서는 재사용
              const now = Date.now();
              let latestBlock: number;
              if (lastBlockNumber && now - lastBlockNumberTime < BLOCK_NUMBER_CACHE_MS) {
                latestBlock = lastBlockNumber;
              } else {
                latestBlock = Number(await this.web3.eth.getBlockNumber());
                lastBlockNumber = latestBlock;
                lastBlockNumberTime = now;
              }

              const confirmations = latestBlock - Number(receipt.blockNumber) + 1;

              console.log(
                `Approve polling - attempt ${i + 1}/${maxAttempts}, confirmations: ${confirmations}, status: ${
                  receipt.status
                }`,
              );

              // REQUIRED_CONFIRMATIONS 이상이면 완료
              if (confirmations >= REQUIRED_CONFIRMATIONS) {
                if (receipt.status === BigInt(1) || Number(receipt.status) === 1) {
                  console.log(`Approve polling completed with ${confirmations} confirmations`);
                  return resolve(receipt);
                } else {
                  return reject(new Error('Approve transaction reverted'));
                }
              }

              // MIN_CONFIRMATIONS 이상이면 receipt 저장 (최종 폴백용)
              if (
                (confirmations >= MIN_CONFIRMATIONS && receipt.status === BigInt(1)) ||
                Number(receipt.status) === 1
              ) {
                console.log(
                  `Approve polling - receipt found with ${confirmations} confirmations (saved for final resolution)`,
                );
              }
              // 아직 충분한 confirmation이 없으면 계속 폴링
            }
          } catch (e: any) {
            // RPC 에러는 재시도, 다른 에러는 throw
            if (e.code === -32002 || e.message?.includes('RPC endpoint') || e.message?.includes('not found')) {
              console.log(`Approve polling retry ${i + 1}/${maxAttempts} for tx: ${hash}`);
              continue;
            }
            // 마지막 시도가 아니면 계속, 아니면 에러 throw
            if (i === maxAttempts - 1) {
              throw e;
            }
          }
        }

        // 최대 시도 후에도 REQUIRED_CONFIRMATIONS에 도달하지 못했지만
        // MIN_CONFIRMATIONS 이상이고 receipt가 있으면 완료 처리
        if (lastReceipt && Number(lastReceipt.status) === 1) {
          const latestBlock = Number(await this.web3.eth.getBlockNumber());
          const confirmations = latestBlock - Number(lastReceipt.blockNumber) + 1;
          if (confirmations >= MIN_CONFIRMATIONS) {
            console.log(
              `Approve polling - completed with ${confirmations} confirmations (minimum threshold after max attempts)`,
            );
            return resolve(lastReceipt);
          }
        }

        // Receipt도 없거나 MIN_CONFIRMATIONS 미만이면 에러
        reject(
          new Error(
            `Failed to get sufficient confirmations after ${maxAttempts} attempts. Receipt found: ${
              lastReceipt ? 'yes' : 'no'
            }`,
          ),
        );
      };

      // REQUIRED_CONFIRMATIONS만큼 confirmation을 기다림
      const approveReceipt = await new Promise<TransactionReceipt>((resolve, reject) => {
        let isResolved = false;
        let pollingStarted = false;
        let minConfirmTimeoutSet = false;

        const safeResolve = (receipt: TransactionReceipt) => {
          if (!isResolved) {
            isResolved = true;
            resolve(receipt);
          }
        };

        const safeReject = (error: Error) => {
          if (!isResolved) {
            isResolved = true;
            reject(error);
          }
        };

        // 트랜잭션 이벤트 리스너 제거 헬퍼 함수
        const removeAllListeners = () => {
          transaction.removeAllListeners('confirmation');
          transaction.removeAllListeners('error');
          transaction.removeAllListeners('receipt');
          transaction.removeAllListeners('transactionHash');
        };

        // 타임아웃 내부에서 사용할 헬퍼 함수들
        const handleTimeoutResolve = (receipt: TransactionReceipt, logMessage: string) => {
          if (!isResolved) {
            console.log(logMessage);
            removeAllListeners();
            safeResolve(receipt);
          }
        };

        const handleTimeoutReject = (error: Error, logMessage: string) => {
          if (!isResolved) {
            console.log(logMessage);
            removeAllListeners();
            safeReject(error);
          }
        };

        const transaction = contract.methods
          .approve(...approveData)
          .send({
            from,
            gas: gasLimit.toString(),
            gasPrice: gasPrice,
            nonce: this.web3.utils.toHex(nonce),
          })
          .on('transactionHash', async (hash: string) => {
            console.log(`Approve transaction hash: ${hash}`);
            txHash = hash;
            // 트랜잭션 해시가 있으면 백그라운드에서 폴링 시작 (confirmation 이벤트가 늦거나 누락될 경우 대비)
            if (!pollingStarted && txHash) {
              pollingStarted = true;
              // 백그라운드 폴링 시작 (Promise는 resolve/reject되지 않음, 확인용)
              pollForConfirmation(txHash, safeResolve, safeReject, 60).catch(() => {
                // 폴링 실패해도 이벤트 핸들러가 처리할 것
              });
            }
          })
          .on('receipt', (receipt: TransactionReceipt) => {
            if (!receiptReceived) {
              console.log(`Approve receipt received: ${receipt.status}`);
              receiptReceived = true;
            }
          })
          .on('confirmation', async (confirmationDetails: ConfirmationDetails) => {
            // 이미 완료된 경우 이벤트 처리 중단 (로그 출력 전에 체크)
            if (isResolved) {
              return;
            }

            const receiptStatus = Number(confirmationDetails.receipt.status);
            confirmationCount = Number(confirmationDetails.confirmations);

            // 성공 상태일 때만 로그 출력 (실패한 트랜잭션은 불필요한 로그 방지)
            if (receiptStatus === 1) {
              console.log(`Approve confirmation count: ${confirmationCount}`);
            }

            // 트랜잭션 실패 시 즉시 종료
            if (receiptStatus !== 1) {
              console.log(`Approve transaction reverted at ${confirmationCount} confirmations`);
              removeAllListeners();
              safeReject(new Error('Approve transaction reverted'));
              return;
            }

            // REQUIRED_CONFIRMATIONS 이상이고 성공 상태일 때만 즉시 완료
            if (confirmationCount >= REQUIRED_CONFIRMATIONS && receiptStatus === 1 && !isResolved) {
              console.log(`Approve completed with ${confirmationCount} confirmations`);
              removeAllListeners();
              safeResolve(confirmationDetails.receipt);
              return;
            }

            // MIN_CONFIRMATIONS 이상이면 완료 가능 (단, REQUIRED_CONFIRMATIONS 미만이면 잠시 대기)
            if (confirmationCount >= MIN_CONFIRMATIONS && receiptStatus === 1 && !isResolved && !minConfirmTimeoutSet) {
              minConfirmTimeoutSet = true;
              console.log(
                `Approve reached minimum confirmations (${confirmationCount}), waiting up to ${MAX_CONFIRMATION_WAIT_TIME}ms for more...`,
              );

              // 타임아웃까지 대기하면서 추가 confirmation 확인
              setTimeout(() => {
                if (!isResolved) {
                  // receipt 상태 확인 (성공 상태일 때만 완료 처리)
                  const finalReceiptStatus = Number(confirmationDetails.receipt.status);
                  if (finalReceiptStatus !== 1) {
                    handleTimeoutReject(
                      new Error('Approve transaction reverted'),
                      'Approve transaction reverted (checked in timeout)',
                    );
                    return;
                  }

                  if (confirmationCount >= REQUIRED_CONFIRMATIONS) {
                    handleTimeoutResolve(
                      confirmationDetails.receipt,
                      `Approve completed with ${confirmationCount} confirmations (after wait)`,
                    );
                  } else if (confirmationCount >= MIN_CONFIRMATIONS) {
                    handleTimeoutResolve(
                      confirmationDetails.receipt,
                      `Approve completed with ${confirmationCount} confirmations (minimum threshold, timeout reached)`,
                    );
                  }
                }
              }, MAX_CONFIRMATION_WAIT_TIME);
            }
          })
          .on('error', async (error: any) => {
            // 이미 완료된 경우 에러 처리 중단
            if (isResolved) {
              return;
            }

            console.error(`Approve transaction error:`, error);

            // RPC 에러이고 txHash가 있으면 receipt를 별도로 조회
            const errorCode = error?.error?.code || error?.code;
            const errorMessage = error?.error?.message || error?.message || '';
            if (
              (errorCode === -32603 ||
                errorCode === -32002 ||
                errorMessage?.includes('RPC endpoint') ||
                errorMessage?.includes('Internal JSON-RPC') ||
                errorMessage?.includes('not found')) &&
              txHash
            ) {
              console.log(`RPC error but txHash exists, fetching receipt manually: ${txHash}`);
              removeAllListeners();

              try {
                // Receipt 조회 재시도
                const receipt = await fetchReceiptWithRetry(txHash);
                // Receipt가 있으면 confirmation도 기다려야 함
                if (receipt.status === BigInt(1) || Number(receipt.status) === 1) {
                  // Confirmation도 확인
                  let confirmations = 0;
                  for (let i = 0; i < 30; i++) {
                    await sleep(2000);
                    const currentReceipt = await this.web3.eth.getTransactionReceipt(txHash);
                    if (currentReceipt) {
                      const latestBlock = await this.web3.eth.getBlockNumber();
                      confirmations = Number(latestBlock) - Number(currentReceipt.blockNumber) + 1;
                      console.log(`Approve manual confirmation count: ${confirmations}`);
                      if (confirmations >= REQUIRED_CONFIRMATIONS) {
                        resolve(currentReceipt);
                        return;
                      }
                    }
                  }
                  // 최대 대기 시간 후에도 충분한 confirmation이 없으면 receipt 반환
                  resolve(receipt);
                } else {
                  reject(new Error('Approve transaction reverted'));
                }
              } catch (retryError) {
                console.error('Failed to fetch receipt after RPC error:', retryError);
                reject(error); // 원본 에러 반환
              }
            } else {
              // RPC 에러가 아니거나 txHash가 없으면 기존 로직대로 reject
              removeAllListeners();
              reject(error);
            }
          });
      });

      console.log(`Approve receipt status: ${approveReceipt.status}`);

      if (Number(approveReceipt.status) === 1) {
        // Approve가 완료되었으므로 다음 nonce 반환 (실제 블록에 포함된 후)
        const currentNonce = Number(await this.web3.eth.getTransactionCount(from, 'pending'));
        return { isApprove: true, nonce: currentNonce, txHash };
      }

      // 트랜잭션은 확정되었으나 상태가 실패인 경우
      const text = `"type": "user", "call": "staking.ts", "method": "handleContractApprove", "req": "{
      "from": "${aPayload.from}", "approveData": "${JSON.stringify(aPayload.approveData)}"}", "msg": "${JSON.stringify(
        approveReceipt,
      )}", "txHash": "${txHash}"`;
      telegramForm(text);
      return { isApprove: false, msg: 'approve fail (Reverted)', code: '400', nonce: null, txHash };
    } catch (e: any) {
      console.error('Approve transaction error:', e);

      // 에러 객체 구조 파싱 (JSON-RPC 형식 또는 일반 에러)
      const errorCode = e?.error?.code || e?.code || e?.data?.code;
      const errorMessage = e?.error?.message || e?.message || e?.data?.message || JSON.stringify(e);
      const errorData = e?.error?.data || e?.data;

      const text = `"type": "user", "call": "staking.ts", "method": "handleContractApprove", "req": "{
         "from": "${aPayload.from}", "approveData": "${JSON.stringify(
        aPayload.approveData,
      )}"}", "msg": "${errorMessage}", "errorCode": "${errorCode}"`;
      telegramForm(text);

      console.error('❌ Approve 트랜잭션 실패');
      console.error('errorCode:', errorCode);
      console.error('errorMessage:', errorMessage);
      console.error('errorData:', errorData);
      console.error('full error:', e);

      // 에러 코드에 따른 메시지 설정
      let userMessage = 'Approve failed';
      if (errorCode === -32603) {
        userMessage = 'Internal RPC error during approve. Please try again.';
      } else if (errorCode === -32002) {
        userMessage = 'RPC endpoint unavailable during approve. Please try again.';
      } else if (errorMessage?.includes('insufficient funds')) {
        userMessage = 'Insufficient funds for gas fee';
      } else if (errorMessage?.includes('revert')) {
        userMessage = 'Approve transaction reverted. Please check token allowance.';
      }

      return {
        isApprove: false,
        msg: userMessage,
        code: String(errorCode || 500),
        nonce: null,
      };
    }
  }
  private async handleContractStakeToken(aPayload: any) {
    const { method, contractAddr, from, data } = aPayload;
    if (!method || !data || !Array.isArray(data)) {
      throw new Error('Invalid method or data');
    }
    const contractAddress = contractAddr.toLocaleLowerCase();
    const contract = this.contracts[contractAddress];
    if (!contract) {
      return { code: 400, data: null, msg: 'The contract was not found', hash: null };
    }

    // approve 선행 처리
    const approveResult = await this.handleContractApprove(aPayload);
    if (!approveResult.isApprove) {
      return {
        code: approveResult.code || 400,
        data: null,
        msg: approveResult.msg || 'Approve failed',
        hash: approveResult.txHash || null,
      };
    }

    // Approve 트랜잭션이 완전히 처리될 때까지 추가 대기 (메인넷 안정성을 위해)
    console.log(`Approve completed, waiting for block confirmation before staking...`);
    await sleep(2000); // 2초 추가 대기

    // Stake 전 풀 상태 및 조건 사전 확인
    try {
      console.log('Checking pool state and conditions before staking...');
      const poolDetails = await this.getPoolDetails(contractAddr);
      const requiredAmount = BigNumber(data[0]);
      const minStakeAmount = BigNumber(poolDetails.minStakePrice || '0');

      // 최소 스테이킹 금액 확인
      if (minStakeAmount.gt(0) && requiredAmount.lt(minStakeAmount)) {
        return {
          code: 400,
          data: null,
          msg: `Amount is less than minimum stake price. Required: ${weiToEth(
            minStakeAmount.toString(),
          )}, Provided: ${weiToEth(requiredAmount.toString())}`,
          hash: null,
        };
      }
    } catch (preCheckError: any) {
      console.error('Pool pre-check error:', preCheckError);
      // 사전 확인 실패해도 계속 진행 (경고만)
      console.warn('⚠️ Could not verify pool state, proceeding with caution...');
    }

    const RETRY_COUNT = 10; // allowance 확인 재시도 횟수 (20 → 10으로 감소)
    // Approve 후 실제 allowance 확인 (스캔에서 revert로 보일 경우 대비)
    try {
      const { from } = aPayload;
      const contractAddress = aPayload.contractAddr.toLocaleLowerCase();
      const erc20Contract = this.erc20Contract[contractAddress];

      if (!erc20Contract) {
        console.error(`ERC20 contract not found for staking contract: ${contractAddress}`);
        console.warn('⚠️ Could not verify allowance - ERC20 contract not initialized, proceeding with caution...');
      } else {
        const stakingContractAddr = contractAddress; // staking 컨트랙트 주소 (spender)
        const requiredAmount = BigNumber(data[0]); // 스테이킹하려는 금액

        // Approve 트랜잭션 receipt에서 Approval 이벤트 확인
        let approvalEventFound = false;
        const approveTxHash = (approveResult as any).txHash || null;
        if (approveTxHash) {
          try {
            const receipt = await this.web3.eth.getTransactionReceipt(approveTxHash);
            if (receipt && receipt.logs) {
              const approvalEventSignature = 'Approval(address,address,uint256)';
              const approvalTopic = this.web3.utils.keccak256(approvalEventSignature);
              approvalEventFound = receipt.logs.some((log: any) => {
                return log.topics && log.topics[0] === approvalTopic;
              });
              if (approvalEventFound) {
                console.log('✅ Approval event found in transaction receipt');
              } else {
                console.warn('⚠️ Approval event not found in receipt - transaction may have reverted');
              }
            }
          } catch (receiptError) {
            console.warn('Could not check approval event in receipt:', receiptError);
          }
        }

        // 최대 10번 재시도하여 allowance 확인 (간격 증가: 3초 → 5초)
        let allowance = BigNumber(0);
        for (let retry = 0; retry < RETRY_COUNT; retry++) {
          try {
            // 더 긴 대기 시간 (첫 시도는 즉시, 이후는 5초)
            if (retry > 0) {
              await sleep(5000); // 3초 → 5초로 증가
            }

            const allowanceWei = await erc20Contract.methods.allowance(from, stakingContractAddr).call();
            allowance = BigNumber(String(allowanceWei));
            console.log(
              `Allowance check ${
                retry + 1
              }/${RETRY_COUNT}: ${allowance.toString()}, Required: ${requiredAmount.toString()}, Token: ${
                erc20Contract.options.address
              }, Spender: ${stakingContractAddr}`,
            );

            // Allowance가 충분한지 확인
            if (allowance.gte(requiredAmount)) {
              console.log(`✅ Allowance confirmed: ${allowance.toString()} >= ${requiredAmount.toString()}`);
              break;
            }

            // 마지막 시도는 하지 않음
          } catch (allowanceError: any) {
            console.error(`Allowance check error (retry ${retry + 1}):`, allowanceError);
            if (retry === RETRY_COUNT - 1) {
              throw new Error(`Failed to verify allowance after ${RETRY_COUNT} attempts: ${allowanceError.message}`);
            }
          }
        }

        // Allowance가 부족하면 에러
        if (allowance.lt(requiredAmount)) {
          // Approval 이벤트가 있었는데 allowance가 0이면 다른 문제일 수 있음
          let errorMsg = `Insufficient allowance. Approved: ${allowance.toString()}, Required: ${requiredAmount.toString()}.`;
          if (approvalEventFound) {
            errorMsg += ` Approval event was found but allowance is not updated. This may be a network sync issue.`;
          } else {
            errorMsg += ` The approve transaction may have reverted. Please check the transaction on block explorer.`;
          }
          errorMsg += `\nToken: ${erc20Contract.options.address}, Spender: ${stakingContractAddr}`;

          console.error(errorMsg);
          return {
            code: 400,
            data: null,
            msg: errorMsg,
            hash: approveTxHash || null,
          };
        }
      }
    } catch (allowanceCheckError: any) {
      console.error('Error checking allowance after approve:', allowanceCheckError);
      // Allowance 확인 실패해도 계속 진행 (경고만)
      console.warn('⚠️ Could not verify allowance, proceeding with caution...');
    }

    // 최신 nonce를 다시 가져와서 안전하게 사용 (approve 트랜잭션이 블록에 포함된 후)
    let currentNonce: number = 0;
    try {
      // 최대 10번 재시도하여 nonce가 안정화될 때까지 대기
      for (let i = 0; i < RETRY_COUNT; i++) {
        const pendingNonce = Number(await this.web3.eth.getTransactionCount(from, 'pending'));
        const latestNonce = Number(await this.web3.eth.getTransactionCount(from, 'latest'));

        // pending과 latest nonce가 안정화되면 사용
        if (pendingNonce === latestNonce + 1 || pendingNonce === latestNonce) {
          currentNonce = pendingNonce;
          break;
        }

        if (i < RETRY_COUNT - 1) {
          await sleep(2000); // 1초 → 2초로 증가 (RPC 호출 빈도 감소)
        } else {
          currentNonce = pendingNonce; // 마지막 시도에서는 pending nonce 사용
        }
      }
    } catch (e) {
      console.error('Error getting nonce:', e);
      // 폴백: approveResult에서 받은 nonce + 1 사용
      if (approveResult.nonce !== null && approveResult.nonce !== undefined) {
        currentNonce = Number(approveResult.nonce) + 1;
      } else {
        // 최종 폴백: 최신 nonce 가져오기
        currentNonce = Number(await this.web3.eth.getTransactionCount(from, 'pending'));
      }
    }

    console.log(`Stake transaction nonce: ${currentNonce}`);

    let txHash: string | null = null;
    let receiptReceived = false;

    // Receipt를 별도로 조회하는 함수 (RPC 에러 대비)
    const fetchReceiptWithRetry = async (hash: string, maxRetries: number = 30): Promise<TransactionReceipt> => {
      for (let i = 0; i < maxRetries; i++) {
        try {
          await sleep(2000); // 2초 대기
          const receipt = await this.web3.eth.getTransactionReceipt(hash);
          if (receipt) {
            return receipt;
          }
        } catch (e: any) {
          // RPC 에러는 재시도, 다른 에러는 throw
          if (e.code === -32002 || e.message?.includes('RPC endpoint') || e.message?.includes('not found')) {
            console.log(`Stake receipt fetch retry ${i + 1}/${maxRetries} for tx: ${hash}`);
            continue;
          }
          throw e;
        }
      }
      throw new Error(`Failed to get transaction receipt after ${maxRetries} retries`);
    };

    try {
      const gasPrice = await this.gasPrice();

      let gasEstimate;
      const estimateGasWithRetry = async (maxRetries: number = 5): Promise<bigint> => {
        for (let i = 0; i < maxRetries; i++) {
          try {
            const estimate = await contract.methods[method](...data).estimateGas({ from: from });
            return estimate;
          } catch (e: any) {
            const errorCode = e?.error?.code || e?.code;
            const errorMessage = e?.error?.message || e?.message || '';
            const errorData = e?.error?.data || e?.data;

            // RPC 에러 및 execution reverted 에러 모두 재시도
            // execution reverted는 네트워크 동기화 문제나 일시적인 상태 변경으로 인해 발생할 수 있음
            const isRpcError =
              (errorCode === -32603 && !errorData?.code) || // RPC 에러이지만 컨트랙트 revert는 아님
              errorCode === -32002 ||
              (errorMessage?.includes('RPC') && !errorMessage?.includes('execution reverted')) ||
              errorMessage?.includes('Internal JSON-RPC') ||
              errorMessage?.includes('not found') ||
              errorMessage?.includes('unavailable');

            const isExecutionReverted = errorData?.code === 3 || errorData?.message === 'execution reverted';

            // RPC 에러 또는 execution reverted 에러인 경우 재시도
            if ((isRpcError || isExecutionReverted) && i < maxRetries - 1) {
              if (isExecutionReverted) {
                console.log(`Gas estimate retry ${i + 1}/${maxRetries} due to execution reverted (may be temporary)`);
              } else {
                console.log(`Gas estimate retry ${i + 1}/${maxRetries} due to RPC error`);
              }
              await sleep(2000); // 2초 대기 후 재시도
              continue;
            }

            // 마지막 시도이거나 재시도 대상이 아닌 경우에도 루프를 계속 진행하여 최대 가스량 반환
            // 재시도 대상이 아닌 에러(예: 실제 컨트랙트 에러)도 최대 시도 후에는 최대 가스량으로 진행
            if (i === maxRetries - 1) {
              // 마지막 시도이면 루프 종료 후 최대 가스량 반환
              break;
            }
            // 아직 시도할 기회가 있으면 continue하지 않고 루프를 계속 진행
            // (재시도 대상이 아닌 에러는 즉시 다음 루프로 넘어가거나 종료)
            continue;
          }
        }
        // 최대 시도 후에도 실패하면 최대 가스량 사용
        console.warn(
          `⚠️ Failed to estimate gas after ${maxRetries} retries. Using maximum gas limit: ${this.MAX_GAS_LIMIT}`,
        );
        return BigInt(this.MAX_GAS_LIMIT);
      };

      gasEstimate = await estimateGasWithRetry();
      const gasLimitRaw = BigNumber(String(gasEstimate)).multipliedBy(MULTIPLIE_PERCENT);
      const gasLimit = gasLimitRaw.gt(this.MAX_GAS_LIMIT) ? this.MAX_GAS_LIMIT.toString() : gasLimitRaw.toFixed(0);
      console.log(
        `Stake gasLimit: ${gasLimit} (estimated: ${gasEstimate.toString()}, multiplier: ${MULTIPLIE_PERCENT})`,
      );

      let confirmationCount = 0;

      // Confirmation을 수동으로 확인하는 폴링 함수 (exponential backoff 적용)
      const pollForStakeConfirmation = async (
        hash: string,
        resolve: (receipt: TransactionReceipt) => void,
        reject: (error: Error) => void,
        maxAttempts: number = 60, // 최대 시도 횟수
      ) => {
        let lastReceipt: TransactionReceipt | null = null;
        let lastBlockNumber: number | null = null;
        let lastBlockNumberTime: number = 0;
        const BLOCK_NUMBER_CACHE_MS = 2000; // 2초간 블록 번호 캐싱

        for (let i = 0; i < maxAttempts; i++) {
          try {
            // Exponential backoff: 2초 → 4초 → 8초 (최대 8초)
            const baseDelay = 2000; // 2초
            const maxDelay = 8000; // 최대 8초
            const delay = Math.min(baseDelay * Math.pow(2, Math.floor(i / 3)), maxDelay);

            if (i > 0) {
              await sleep(delay);
            }

            const receipt = await this.web3.eth.getTransactionReceipt(hash);

            if (receipt) {
              lastReceipt = receipt;

              // 블록 번호 캐싱: 같은 블록 내에서는 재사용
              const now = Date.now();
              let latestBlock: number;
              if (lastBlockNumber && now - lastBlockNumberTime < BLOCK_NUMBER_CACHE_MS) {
                latestBlock = lastBlockNumber;
              } else {
                latestBlock = Number(await this.web3.eth.getBlockNumber());
                lastBlockNumber = latestBlock;
                lastBlockNumberTime = now;
              }

              const confirmations = latestBlock - Number(receipt.blockNumber) + 1;

              console.log(
                `Stake polling - attempt ${i + 1}/${maxAttempts}, confirmations: ${confirmations}, status: ${
                  receipt.status
                }`,
              );

              // REQUIRED_CONFIRMATIONS 이상이면 완료
              if (confirmations >= REQUIRED_CONFIRMATIONS) {
                if (receipt.status === BigInt(1) || Number(receipt.status) === 1) {
                  console.log(`Stake polling completed with ${confirmations} confirmations`);
                  return resolve(receipt);
                } else {
                  return reject(new Error('Stake transaction reverted'));
                }
              }

              // MIN_CONFIRMATIONS 이상이면 receipt 저장 (최종 폴백용)
              if (
                (confirmations >= MIN_CONFIRMATIONS && receipt.status === BigInt(1)) ||
                Number(receipt.status) === 1
              ) {
                console.log(
                  `Stake polling - receipt found with ${confirmations} confirmations (saved for final resolution)`,
                );
              }
              // 아직 충분한 confirmation이 없으면 계속 폴링
            }
          } catch (e: any) {
            // RPC 에러는 재시도, 다른 에러는 throw
            if (e.code === -32002 || e.message?.includes('RPC endpoint') || e.message?.includes('not found')) {
              console.log(`Stake polling retry ${i + 1}/${maxAttempts} for tx: ${hash}`);
              continue;
            }
            // 마지막 시도가 아니면 계속, 아니면 에러 throw
            if (i === maxAttempts - 1) {
              throw e;
            }
          }
        }

        // 최대 시도 후에도 REQUIRED_CONFIRMATIONS에 도달하지 못했지만
        // MIN_CONFIRMATIONS 이상이고 receipt가 있으면 완료 처리
        if (lastReceipt && Number(lastReceipt.status) === 1) {
          const latestBlock = Number(await this.web3.eth.getBlockNumber());
          const confirmations = latestBlock - Number(lastReceipt.blockNumber) + 1;
          if (confirmations >= MIN_CONFIRMATIONS) {
            console.log(
              `Stake polling - completed with ${confirmations} confirmations (minimum threshold after max attempts)`,
            );
            return resolve(lastReceipt);
          }
        }

        // Receipt도 없거나 MIN_CONFIRMATIONS 미만이면 에러
        reject(
          new Error(
            `Failed to get sufficient confirmations after ${maxAttempts} attempts. Receipt found: ${
              lastReceipt ? 'yes' : 'no'
            }`,
          ),
        );
      };

      const stakeReceipt = await new Promise<TransactionReceipt>((resolve, reject) => {
        let isResolved = false;
        let pollingStarted = false;
        let minConfirmTimeoutSet = false;

        const safeResolve = (receipt: TransactionReceipt) => {
          if (!isResolved) {
            isResolved = true;
            resolve(receipt);
          }
        };

        const safeReject = (error: Error) => {
          if (!isResolved) {
            isResolved = true;
            reject(error);
          }
        };

        // 트랜잭션 이벤트 리스너 제거 헬퍼 함수
        const removeAllListeners = () => {
          transaction.removeAllListeners('confirmation');
          transaction.removeAllListeners('error');
          transaction.removeAllListeners('receipt');
          transaction.removeAllListeners('transactionHash');
        };

        // 타임아웃 내부에서 사용할 헬퍼 함수들
        const handleTimeoutResolve = (receipt: TransactionReceipt, logMessage: string) => {
          if (!isResolved) {
            console.log(logMessage);
            removeAllListeners();
            safeResolve(receipt);
          }
        };

        const handleTimeoutReject = (error: Error, logMessage: string) => {
          if (!isResolved) {
            console.log(logMessage);
            removeAllListeners();
            safeReject(error);
          }
        };
        const transaction = contract.methods[method](...data)
          .send({
            from,
            gas: gasLimit.toString(),
            gasPrice: gasPrice,
            nonce: this.web3.utils.toHex(currentNonce),
          })
          .on('transactionHash', async (hash: string) => {
            console.log(`Stake transaction hash: ${hash}`);
            txHash = hash;
            // 트랜잭션 해시가 있으면 백그라운드에서 폴링 시작 (confirmation 이벤트가 늦거나 누락될 경우 대비)
            if (!pollingStarted && txHash) {
              pollingStarted = true;
              // 백그라운드 폴링 시작 (Promise는 resolve/reject되지 않음, 확인용)
              pollForStakeConfirmation(txHash, safeResolve, safeReject, 60).catch(() => {
                // 폴링 실패해도 이벤트 핸들러가 처리할 것
              });
            }
          })
          .on('receipt', (receipt: TransactionReceipt) => {
            if (!receiptReceived) {
              console.log(`Stake receipt received: ${receipt.status}`);
              receiptReceived = true;
            }
          })
          .on('confirmation', async (confirmationDetails: ConfirmationDetails) => {
            // 이미 완료된 경우 이벤트 처리 중단 (로그 출력 전에 체크)
            if (isResolved) {
              return;
            }

            const receiptStatus = Number(confirmationDetails.receipt.status);
            confirmationCount = Number(confirmationDetails.confirmations);

            // 성공 상태일 때만 로그 출력 (실패한 트랜잭션은 불필요한 로그 방지)
            if (receiptStatus === 1) {
              console.log(`Stake confirmation count: ${confirmationCount}`);
            }

            // 트랜잭션 실패 시 즉시 종료
            if (receiptStatus !== 1) {
              console.log(`Stake transaction reverted at ${confirmationCount} confirmations`);
              removeAllListeners();
              safeReject(new Error('Stake transaction reverted'));
              return;
            }

            // REQUIRED_CONFIRMATIONS 이상이고 성공 상태일 때만 즉시 완료
            if (confirmationCount >= REQUIRED_CONFIRMATIONS && receiptStatus === 1 && !isResolved) {
              console.log(`Stake completed with ${confirmationCount} confirmations`);
              removeAllListeners();
              safeResolve(confirmationDetails.receipt);
              return;
            }

            // MIN_CONFIRMATIONS 이상이면 완료 가능 (단, REQUIRED_CONFIRMATIONS 미만이면 잠시 대기)
            if (confirmationCount >= MIN_CONFIRMATIONS && receiptStatus === 1 && !isResolved && !minConfirmTimeoutSet) {
              minConfirmTimeoutSet = true;
              console.log(
                `Stake reached minimum confirmations (${confirmationCount}), waiting up to ${MAX_CONFIRMATION_WAIT_TIME}ms for more...`,
              );

              // 타임아웃까지 대기하면서 추가 confirmation 확인
              setTimeout(() => {
                if (!isResolved) {
                  // receipt 상태 확인 (성공 상태일 때만 완료 처리)
                  const finalReceiptStatus = Number(confirmationDetails.receipt.status);
                  if (finalReceiptStatus !== 1) {
                    handleTimeoutReject(
                      new Error('Stake transaction reverted'),
                      'Stake transaction reverted (checked in timeout)',
                    );
                    return;
                  }

                  if (confirmationCount >= REQUIRED_CONFIRMATIONS) {
                    handleTimeoutResolve(
                      confirmationDetails.receipt,
                      `Stake completed with ${confirmationCount} confirmations (after wait)`,
                    );
                  } else if (confirmationCount >= MIN_CONFIRMATIONS) {
                    handleTimeoutResolve(
                      confirmationDetails.receipt,
                      `Stake completed with ${confirmationCount} confirmations (minimum threshold, timeout reached)`,
                    );
                  }
                }
              }, MAX_CONFIRMATION_WAIT_TIME);
            }
          })
          .on('error', async (error: any) => {
            // 이미 완료된 경우 에러 처리 중단
            if (isResolved) {
              return;
            }

            console.error(`Stake transaction error:`, error);

            // RPC 에러이고 txHash가 있으면 receipt를 별도로 조회
            const errorCode = error?.error?.code || error?.code;
            const errorMessage = error?.error?.message || error?.message || '';
            if (
              (errorCode === -32603 ||
                errorCode === -32002 ||
                errorMessage?.includes('RPC endpoint') ||
                errorMessage?.includes('Internal JSON-RPC') ||
                errorMessage?.includes('not found')) &&
              txHash
            ) {
              console.log(`RPC error but txHash exists, fetching receipt manually: ${txHash}`);
              removeAllListeners();

              try {
                // Receipt 조회 재시도
                const receipt = await fetchReceiptWithRetry(txHash);
                // Receipt가 있으면 confirmation도 기다려야 함
                if (receipt.status === BigInt(1) || Number(receipt.status) === 1) {
                  // Confirmation도 확인
                  let confirmations = 0;
                  for (let i = 0; i < 30; i++) {
                    await sleep(2000);
                    try {
                      const currentReceipt = await this.web3.eth.getTransactionReceipt(txHash);
                      if (currentReceipt) {
                        const latestBlock = await this.web3.eth.getBlockNumber();
                        confirmations = Number(latestBlock) - Number(currentReceipt.blockNumber) + 1;
                        console.log(`Stake manual confirmation count: ${confirmations}`);
                        if (confirmations >= REQUIRED_CONFIRMATIONS) {
                          resolve(currentReceipt);
                          return;
                        }
                      }
                    } catch (e: any) {
                      // RPC 에러는 재시도 계속
                      if (e.code === -32002 || e.message?.includes('RPC endpoint')) {
                        continue;
                      }
                      throw e;
                    }
                  }
                  // 최대 대기 시간 후에도 충분한 confirmation이 없으면 receipt 반환
                  resolve(receipt);
                } else {
                  reject(new Error('Stake transaction reverted'));
                }
              } catch (retryError) {
                console.error('Failed to fetch receipt after RPC error:', retryError);
                reject(error); // 원본 에러 반환
              }
            } else {
              // RPC 에러가 아니거나 txHash가 없으면 기존 로직대로 reject
              removeAllListeners();
              reject(error);
            }
          });
      });

      if (Number(stakeReceipt.status) === 1) {
        return { code: 200, data: stakeReceipt, msg: 'success', hash: txHash };
      }

      // 트랜잭션은 확정되었으나 상태가 실패인 경우
      console.error(`Stake transaction failed with status: ${stakeReceipt.status}`);
      return { code: 400, data: stakeReceipt, msg: 'Stake transaction failed', hash: txHash };
    } catch (e: any) {
      console.error('Stake transaction error:', e);

      // 에러 객체 구조 파싱 (JSON-RPC 형식 또는 일반 에러)
      const errorCode = e?.error?.code || e?.code || e?.data?.code;
      const errorMessage = e?.error?.message || e?.message || e?.data?.message || '';
      const errorData = e?.error?.data || e?.data;

      // 에러 데이터에서 실제 revert 이유 확인
      let revertReason = '';
      if (errorData) {
        if (errorData.data && typeof errorData.data === 'string' && errorData.data.startsWith('0x')) {
          revertReason = `Revert data: ${errorData.data}`;
        } else if (errorData.message) {
          revertReason = `Revert message: ${errorData.message}`;
        }
      }
      console.error('Revert reason:', revertReason || 'Unknown');
      const userMessage = errorMessage || JSON.stringify(e);

      return {
        code: errorCode || 500,
        data: e,
        msg: userMessage,
        hash: txHash,
      };
    }
  }

  private async handleContractSend(aPayload: any) {
    const { method, contractAddr, from, data } = aPayload;
    if (!method || !data || !Array.isArray(data)) {
      return { code: RES_BAD_REQUEST, data: data, msg: 'Invalid method or data', hash: null };
    }
    const contractAddress = contractAddr.toLocaleLowerCase();
    const contract = this.contracts[contractAddress];
    if (!contract) {
      const text = `"type": "user", "call": "staking.ts", "method": "handleContractSend(), "req": "{
        "aContractAddr": ${contractAddr}, "from": "${from}", "method": "${method}", data: "${JSON.stringify(data)}"}" `;
      telegramForm(text);
      return { code: RES_BAD_REQUEST, data: 'The contract was not found', msg: 'Invalid method or data', hash: null };
    }
    let txHash = null;
    try {
      const nonce = await this.web3.eth.getTransactionCount(from, 'pending');
      console.log(`start nonce: ${nonce}`);
      const gasPrice = await this.gasPrice();
      console.log(`start gasPrice: ${gasPrice}`);
      console.log();
      let gasEstimate = null;
      let approveReceipt = null;

      // method별 기본 가스 한도 (estimateGas 실패 시 사용)
      const getDefaultGasLimit = (method: string): number => {
        switch (method) {
          case UNSTAKETOKEN:
            return 100000; // 100,000 언스테이킹
          case CLAIMREWARD:
            return 200000; // 200,000 리워드 클레임
          case WITHDRAWALLPRINCIPAL:
            return 100000; // 100,000 회수
          case CLAIMALLREWARD:
            return 1000000; // 1,000,000 전체 리워드 클레임
          default:
            return 200000; // 200,000 기본값
        }
      };

      if (data.length > 0) {
        try {
          gasEstimate = BigNumber(await contract.methods[method](...data).estimateGas({ from: from }));
        } catch (estimateError: any) {
          console.warn(`⚠️ Failed to estimate gas for method ${method}. Using default gas limit.`, estimateError);
          const defaultGas = getDefaultGasLimit(method);
          gasEstimate = BigNumber(defaultGas);
          console.log(`Using default gas limit for ${method}: ${defaultGas}`);
        }
        const gasLimitRaw = BigNumber(gasEstimate).multipliedBy(1.2);
        const gasLimit = gasLimitRaw.gt(this.MAX_GAS_LIMIT) ? this.MAX_GAS_LIMIT.toString() : gasLimitRaw.toFixed(0);
        approveReceipt = await new Promise<TransactionReceipt>((resolve, reject) => {
          let isResolved = false;

          const safeReject = (error: any) => {
            if (!isResolved) {
              isResolved = true;
              reject(error);
            }
          };

          const transaction = contract.methods[method](...data)
            .send({ from: from, gas: gasLimit, gasPrice: gasPrice, nonce: this.web3.utils.toHex(nonce) })
            .on('transactionHash', (hash: string) => {
              txHash = hash; // 트랜잭션 해시 저장
            })
            .on('confirmation', (confirmationDetails: ConfirmationDetails) => {
              if (isResolved) {
                return;
              }
              const receiptStatus = Number(confirmationDetails.receipt.status);
              const confirmationNumber = Number(confirmationDetails.confirmations);

              // 트랜잭션 실패 시 즉시 종료
              if (receiptStatus !== 1 && !isResolved) {
                isResolved = true;
                transaction.removeAllListeners();
                reject(new Error('Transaction reverted'));
                return;
              }

              // 첫 번째 컨펌(confirmation number 1)에서 receipt를 받아서 resolve
              // Web3.js에서 confirmation number는 1부터 시작 (1 = 첫 번째 컨펌)
              if (confirmationNumber === 1 && receiptStatus === 1) {
                isResolved = true;
                transaction.removeAllListeners();
                console.log(`Transaction confirmed with receipt status: ${receiptStatus}`);

                resolve(confirmationDetails.receipt);
                return;
              }
            })
            .on('error', (error: any) => {
              if (isResolved) {
                return;
              }
              // 트랜잭션 실패 시 reject (catch 블록으로 전달됨)
              isResolved = true;
              transaction.removeAllListeners();
              reject(error);
            });

          // MetaMask 서명 거부 등 .on('error') 이전에 발생하는 에러 처리
          // PromiEvent와 별도로 catch 처리 (transaction 변수에 영향 주지 않음)
          (transaction as any).catch((error: any) => {
            console.error('Transaction catch error:', error);
            safeReject(error);
          });
        });
        // confirmation 이벤트에서 이미 receiptStatus === 1을 확인했으므로 바로 성공 반환
        // resolve된 receipt는 이미 성공 상태로 확인되었음
        return { code: RES_SUCCESS, data: approveReceipt, hash: txHash };
      } else {
        try {
          gasEstimate = BigNumber(await contract.methods[method]().estimateGas({ from: from }));
        } catch (estimateError: any) {
          console.warn(`⚠️ Failed to estimate gas for method ${method}. Using default gas limit.`, estimateError);
          const defaultGas = getDefaultGasLimit(method);
          gasEstimate = BigNumber(defaultGas);
          console.log(`Using default gas limit for ${method}: ${defaultGas}`);
        }
        const gasLimitRaw = BigNumber(gasEstimate).multipliedBy(1.2);
        const gasLimit = gasLimitRaw.gt(this.MAX_GAS_LIMIT) ? this.MAX_GAS_LIMIT.toString() : gasLimitRaw.toFixed(0);
        approveReceipt = await new Promise<TransactionReceipt>((resolve, reject) => {
          let isResolved = false;

          const safeReject = (error: any) => {
            if (!isResolved) {
              isResolved = true;
              reject(error);
            }
          };

          const transaction = contract.methods[method]()
            .send({ from: from, gas: gasLimit, gasPrice: gasPrice, nonce: this.web3.utils.toHex(nonce) })
            .on('transactionHash', (hash: string) => {
              txHash = hash; // 트랜잭션 해시 저장
            })
            // 🚨 3. on('confirmation')을 사용하여 첫 번째 컨펌에서 receipt 받기
            .on('confirmation', (confirmationDetails: ConfirmationDetails) => {
              if (isResolved) {
                return;
              }
              const receiptStatus = Number(confirmationDetails.receipt.status);
              const confirmationNumber = Number(confirmationDetails.confirmations);

              // 트랜잭션 실패 시 즉시 종료
              if (receiptStatus !== 1 && !isResolved) {
                isResolved = true;
                transaction.removeAllListeners();
                reject(new Error('Transaction reverted'));
                return;
              }

              // 첫 번째 컨펌(confirmation number 1)에서 receipt를 받아서 resolve
              // Web3.js에서 confirmation number는 1부터 시작 (1 = 첫 번째 컨펌)
              if (confirmationNumber === 1 && receiptStatus === 1) {
                isResolved = true;
                transaction.removeAllListeners();
                console.log(`Transaction confirmed with receipt status: ${receiptStatus}`);
                resolve(confirmationDetails.receipt);
                return;
              }
            })
            .on('error', (error: any) => {
              if (isResolved) {
                return;
              }
              // 트랜잭션 실패 시 reject (catch 블록으로 전달됨)
              isResolved = true;
              transaction.removeAllListeners();
              reject(error);
            });

          // MetaMask 서명 거부 등 .on('error') 이전에 발생하는 에러 처리
          // PromiEvent와 별도로 catch 처리 (transaction 변수에 영향 주지 않음)
          (transaction as any).catch((error: any) => {
            console.error('Transaction catch error:', error);
            safeReject(error);
          });
        });
        // confirmation 이벤트에서 이미 receiptStatus === 1을 확인했으므로 바로 성공 반환
        // resolve된 receipt는 이미 성공 상태로 확인되었음
        return { code: RES_SUCCESS, data: approveReceipt, hash: txHash };
        // on이용해서 txhash 가져오기 테스트 중
        // re = await contract.methods[method]().send({ from: from, gas: gasEstimate, gasPrice: gasPrice });
        // await contract.methods
        // .send({
        //   from,
        //   gas: gasEstimate.toString(),
        //   gasPrice: gasPrice,
        // })
        // .on('transactionHash', (hash: string) => {
        //   console.log(`transactionHash ffffffffffffff`);
        //   console.log(hash);
        // });
      }
    } catch (e: any) {
      console.error(e);
      const err = e as { code: string; message: string };
      const text = `"type": "user", "call": "staking.ts", "method": "handleContractSend(), "req": "{
        "aContractAddr": ${contractAddr}, "from": "${from}", "method": "${method}", data: "${JSON.stringify(
        data,
      )}"}", error: ${e?.data?.message ?? e?.message}, err: ${JSON.stringify(e)}, hash: ${txHash} `;
      telegramForm(text);
      return {
        code: e?.data?.code ?? err.code ?? RES_BAD_REQUEST,
        data: e?.data?.message ?? err?.message,
        msg: e?.data?.message ?? err?.message,
        hash: txHash,
      };
    }
  }
  // 토큰을 스테이킹합니다.
  async stakeToken(contractAddr: string, aPayload: TypeStakingAprroveActionPayload) {
    const amount = ethToWei(aPayload[1]);
    const payload = {
      method: STAKKINGTOKEN,
      from: aPayload[0],
      contractAddr,
      data: [amount],
      approveData: [contractAddr, amount],
    };
    const re = await this.handleContractStakeToken(payload);

    // 에러 발생 시 즉시 반환
    if (re.code !== 200) {
      return re;
    }

    // 이벤트 확인 및 처리
    const receipt = re.data as TransactionReceipt;
    const stakedEvent = receipt.events?.Staked;
    if (stakedEvent) {
      try {
        if (stakedEvent && typeof re.data === 'object' && re.data !== null) {
          const { user, amount } = (stakedEvent as any).returnValues;
          (re.data as any).contractAddress = user ?? '';
          (re.data as any).contractAmount = String(weiToEth(amount ?? '0'));
        }
      } catch (err) {
        console.error('Error processing stakedEvent:', err);
      }
    }
    return re;
  }
  // // 토큰을 언스테이킹합니다.
  async unStakeToken(contractAddr: string, aPayload: TypeUnStakingActionPayload) {
    const payload = {
      method: UNSTAKETOKEN,
      from: aPayload[0],
      contractAddr: contractAddr.toLocaleLowerCase(),
      data: [aPayload[1], ethToWei(aPayload[2])],
    };
    return await this.handleContractSend(payload);
  }
  // 스테이킹 별 보상을 청구합니다.
  async claimReward(
    contractAddr: string,
    aPayload: TypeStakingPayload,
  ): Promise<{ code: number; data: TransactionReceipt | string; hash: string | null }> {
    const payload = {
      method: CLAIMREWARD,
      from: aPayload[0],
      contractAddr,
      data: [aPayload[1]],
    };
    const re = await this.handleContractSend(payload);
    if (re.code === RES_SUCCESS) {
      const events = re.data?.events?.RewardClaimed;
      if (events) {
        const { user, reward } = events.returnValues;
        console.log(`event `);
        console.log(user);
        console.log(reward);
        re.data.contractAddress = user;
        re.data.contractReward = String(weiToEth(reward)) ?? '0';
      }
    }
    // 응답값 트랜잭션 레시피
    return re;
  }
  // 원금을 회수합니다.
  async withdrawAllPrincipal(contractAddr: string, aPayload: TypeStakingPayload) {
    const payload = {
      method: WITHDRAWALLPRINCIPAL,
      from: aPayload[0],
      contractAddr,
      data: [],
    };
    const re = await this.handleContractSend(payload);
    if (re.code === 200) {
      const events = re.data?.events?.PrincipalWithdrawn;
      if (events) {
        const { user, totalAmount } = events.returnValues;
        re.data.contractAddress = user;
        re.data.contractWithdrawAmt = totalAmount ? String(weiToEth(totalAmount)) : '0';
      } else {
        // logs에서 PrincipalWithdrawn 이벤트 파싱
        const logs = re.data?.logs;
        if (logs && Array.isArray(logs)) {
          const eventTopic = this.web3.utils.keccak256('PrincipalWithdrawn(address,uint256)');
          const eventLog = logs.find((log: any) => log.topics?.[0]?.toLowerCase() === eventTopic.toLowerCase());
          if (eventLog) {
            const user = '0x' + eventLog.topics[1].slice(26);
            const totalAmount = this.web3.utils.hexToNumberString(eventLog.data);
            re.data.contractAddress = user;
            re.data.contractWithdrawAmt = totalAmount ? String(weiToEth(totalAmount)) : '0';
          } else {
            re.data.contractWithdrawAmt = '0';
          }
        } else {
          re.data.contractWithdrawAmt = '0';
        }
      }
    }
    return re;
  }
  // 사용자의 전체 보상을 요청합니다.
  async claimAllReward(contractAddr: string, aPayload: TypeStakingPayload) {
    const payload = {
      method: CLAIMALLREWARD,
      from: aPayload[0],
      contractAddr,
      data: [],
    };
    const re = await this.handleContractSend(payload);
    console.log(`claimAllReward`);
    console.log(JSON.stringify(re));
    if (re.code === RES_SUCCESS) {
      const events = re.data?.events?.RewardClaimed;
      if (events) {
        let totalReward = BigNumber(0); // BigNumber 초기화

        if (Array.isArray(events)) {
          // 배열을 순회하며 합산
          events.forEach((item) => {
            const { reward } = item.returnValues;

            totalReward = totalReward.plus(BigNumber(reward));
          });
        } else {
          // 단일 이벤트일 경우 처리
          const { reward } = events.returnValues;

          totalReward = totalReward.plus(BigNumber(reward));
        }
        re.data.contractAmount = weiToEth(totalReward.toFixed());
      }
    }
    return re;
  }
  ///////////////////////////////////////////////////////////////////
  // 풀의 세부사항을 조회합니다.

  async getPoolDetails(contractAddr: string): Promise<ResGetPoolDetailsCall> {
    const { code, data } = await this.handleContractCall1(GETPOOLDETAILS, contractAddr, []);
    if (code !== RES_SUCCESS) {
      return data;
    }

    const obj: ResGetPoolDetailsCall = {
      annualInterestMultipliedRate: dividedNum(String(data.annualInterestMultipliedRate), 100, 1),
      description: data.description,
      maxFundraisingPrice: String(data.maxFundraisingPrice),
      minFundraisingPrice: String(data.minFundraisingPrice),
      minStakePrice: String(data.minStakePrice),
      name: data.name,
      stakingToken: data.stakingToken,
    };
    return obj;
  }
  // 사용자의 스테이킹 개수를 조회합니다.
  async getStakeCount(contractAddr: string, aPayload: TypeStakingPayload): Promise<String> {
    const { code, data } = await this.handleContractCall1(GETSTAKECOUNT, contractAddr, aPayload);
    if (code !== RES_SUCCESS) {
      return data;
    }
    const res = String(data);
    return res;
    // const data = [address];
    // return await this.handleContractCall(GETSTAKECOUNT, symbol, data);
  }
  // 사용자의 특정 스테이킹 정보를 조회하는 함수
  async getStake(contractAddr: string, aPayload: TypeStakingPayload): Promise<ResGetStakeCall> {
    const { code, data } = await this.handleContractCall1(GETSTAKE, contractAddr, aPayload);
    if (code !== RES_SUCCESS) {
      return data;
    }
    const result: ResGetStakeCall = {
      amountStaked: String(weiToEth(data.amountStaked)),
      stakeTime: unixToDate(data.stakeTime), // String(data.stakeTime),
      claimedReward: data.claimedReward ? String(weiToEth(data.claimedReward)) : '0',
      pendingRewardScheduleIndex: String(data.pendingRewardScheduleIndex),
      tokenMultipliedPrice: String(converterToEth(data.tokenMultipliedPrice, 'szabo')), // 단위가 szabo이유: 10의 6승으로표시
      dailyInterestMultipliedPriceAndRate: String(converterToEth(data.dailyInterestMultipliedPriceAndRate, 'szabo')),
    };
    return result;
  }
  // 사용자의 전체 스테이킹 금액을 조회
  async getTotalStakedAmount(contractAddr: string, aPayload: TypeStakingPayload) {
    const { code, data } = await this.handleContractCall1(GETTOTALSTAKEDAMOUNT, contractAddr, aPayload);
    if (code !== RES_SUCCESS) {
      return data;
    }
    return weiToEth(data);
  }
  // 특정 스테이킹에 대해 받을 보상을 조회
  async calculatePendingRewardForStake(
    contractAddr: string,
    aPayload: TypeStakingPayload,
  ): Promise<ResCalculatePendingRewardForStakeCall> {
    const { code, data } = await this.handleContractCall1(CALCULATEPENDINGREWARDFORSTAKE, contractAddr, aPayload);
    if (code !== RES_SUCCESS) {
      return data;
    }
    const obj: ResCalculatePendingRewardForStakeCall = {
      reward: String(data[0]),
      nextIndex: String(data[1]),
    };
    return obj;
  }
  // 사용자가 받을 전체 보상 금액
  async calculatePendingRewardForAllStakes(contractAddr: string, aPayload: TypeStakingPayload) {
    // TODO 운영 상태일때만 가능
    const { code, data } = await this.handleContractCall1(CALCULATEPENDINGREWARDFORALLSTAKES, contractAddr, aPayload);
    if (code !== RES_SUCCESS) {
      return data;
    }
    return String(weiToEth(data)); // data; // String(weiToEth(data));
  }
  // 사용자가 청구한 전체 보상 금액을 조회
  async calculateClaimedRewardForAllStakes(contractAddr: string, aPayload: TypeStakingPayload) {
    // TODO 운영, 종료, 중지 상태일때만 가능
    const { code, data } = await this.handleContractCall1(CALCULATECLAIMEDREWARDFORALLSTAKES, contractAddr, aPayload);
    if (code !== RES_SUCCESS) {
      return data;
    }
    return String(data);
  }
  // Pool 의 상태를 나타내는 열거형
  async state(contractAddr: string): Promise<string> {
    const { code, data } = await this.handleContractCall1(STATE, contractAddr, []);
    if (code !== RES_SUCCESS) {
      return data;
    }
    return String(data);
  }
  // 보상 스케줄을 정의하는 구조체
  async rewardSchedules(contractAddr: string, index: string = '0'): Promise<ResRewardSchedules> {
    const { code, data } = await this.handleContractCall1(REWARDSCHEDULE, contractAddr, [index]);
    if (code !== RES_SUCCESS) {
      return data;
    }
    const obj = {
      tokenMultipliedPriceAtPayout: String(data.tokenMultipliedPriceAtPayout),
      start: unixToDate(data.start),
      end: unixToDate(data.end),
    };
    return obj;
  }
  // 총 모금액 확인 (ex. 총 모금액이 $100 인 경우 실제 값은 100 x PRICE_MULTIPLIER)
  async totalFundraisingMultipliedPrice(contractAddr: string): Promise<string> {
    const { code, data } = await this.handleContractCall1(TOTALFUNDRAISINGMULTIPLIEDPRICE, contractAddr, []);
    if (code !== RES_SUCCESS) {
      return data;
    }
    return String(converterToEth(data, 'szabo'));
  }
  // 보상 스케줄의 개수
  async getRewardScheduleCount(contractAddr: string) {
    const { code, data } = await this.handleContractCall1(GETREWARDSCHEDULECOUNT, contractAddr, []);
    if (code !== RES_SUCCESS) {
      return data;
    }
    return String(data);
  }
}
